<template>
  <icon-button
    type="button"
    icon="ios_share"
    classes="-ico-only share"
    label="Share"
    aria-label="Share Collection"
    :disabled="disabled"
    :icons-outlined="false"
    @click-action="openModal"
  />
</template>

<script setup lang="ts">
import IconButton from '@/components/buttons/icon-button.vue'
import { useModalsStore } from '@/stores/modals'
import type { FilterCollection } from '@/types/model-types'
import { computed } from 'vue'

/** PROPS **/
const props = withDefaults(
  defineProps<{
    filterCollection: FilterCollection
    disabled?: boolean
  }>(),
  {
    disabled: false,
  },
)

/** STATE **/
const modalsStore = useModalsStore()

/** COMPUTED **/
const modalId = computed(() => `filter-collection-share-${props.filterCollection.id}`)

/** METHODS **/
function openModal() {
  modalsStore.openSimpleModal({
    type: 'FILTER_COLLECTION',
    id: modalId.value,
    props: {
      screen: 'share',
      filterCollection: props.filterCollection,
    },
  })
}
</script>
